// Auto generated file, do not manually modify!
// com.hotpads.capps.handler.web.landlord.v1.CappsLandlordUserDetailsWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { LandlordUserDetailsResponseDto } from '../..';

export const CappsLandlordUserDetailsWebApiHandler_details_Path = '/api/web/landlord/v1/user/details';

export const CappsLandlordUserDetailsWebApiHandler_details = (client = getClient()) => {
  return httpFrontEndRequest<never, never, LandlordUserDetailsResponseDto>(
    {
      endpoint: CappsLandlordUserDetailsWebApiHandler_details_Path,
      method: 'GET',
      contextPath: '/capps',
    },
    client,
  );
};
